@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import io.horion.auth.presentation.ui.components.layouts.PageLayout as _io_horion_auth_presentation_ui_components_layouts_PageLayout
import io.horion.auth.presentation.ui.pages.login.loginPage as _io_horion_auth_presentation_ui_pages_login_loginPage
import io.horion.auth.presentation.ui.pages.logout.logoutPage as _io_horion_auth_presentation_ui_pages_logout_logoutPage
import io.horion.auth.presentation.ui.pages.password.forgetPasswordPage as _io_horion_auth_presentation_ui_pages_password_forgetPasswordPage
import io.horion.auth.presentation.ui.pages.password.resetPasswordPage as _io_horion_auth_presentation_ui_pages_password_resetPasswordPage
import io.horion.auth.presentation.ui.pages.profile.FaqPage as _io_horion_auth_presentation_ui_pages_profile_FaqPage
import io.horion.auth.presentation.ui.pages.profile.ProfilePage as _io_horion_auth_presentation_ui_pages_profile_ProfilePage
import io.horion.auth.presentation.ui.pages.register.registerPage as _io_horion_auth_presentation_ui_pages_register_registerPage
import io.horion.auth.presentation.ui.pages.verification.verifyPage as _io_horion_auth_presentation_ui_pages_verification_verifyPage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Orion Auth", "version" to "20260915.1715"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "io.horion.auth.presentation.ui.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _io_horion_auth_presentation_ui_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
            layoutId = "io.horion.auth.presentation.ui.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                io.horion.auth.presentation.ui.pages.login.initLoginPage(ctx)
            },
        ) { pageCtx -> 
            _io_horion_auth_presentation_ui_pages_login_loginPage()
        }
        ctx.router.register(
            "/faq",
        ) { pageCtx -> 
            _io_horion_auth_presentation_ui_pages_profile_FaqPage()
        }
        ctx.router.register(
            "/forget-password",
            layoutId = "io.horion.auth.presentation.ui.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                io.horion.auth.presentation.ui.pages.password.initForgetPasswordPage(ctx)
            },
        ) { pageCtx -> 
            _io_horion_auth_presentation_ui_pages_password_forgetPasswordPage()
        }
        ctx.router.register(
            "/logout",
            initRouteMethod = { ctx ->
                io.horion.auth.presentation.ui.pages.logout.initLogoutPage(ctx)
            },
        ) { pageCtx -> 
            _io_horion_auth_presentation_ui_pages_logout_logoutPage()
        }
        ctx.router.register(
            "/profile",
            layoutId = "io.horion.auth.presentation.ui.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                io.horion.auth.presentation.ui.pages.profile.initProfilePage(ctx)
            },
        ) { pageCtx -> 
            _io_horion_auth_presentation_ui_pages_profile_ProfilePage()
        }
        ctx.router.register(
            "/register",
            layoutId = "io.horion.auth.presentation.ui.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                io.horion.auth.presentation.ui.pages.register.initRegisterPage(ctx)
            },
        ) { pageCtx -> 
            _io_horion_auth_presentation_ui_pages_register_registerPage()
        }
        ctx.router.register(
            "/reset-password",
            layoutId = "io.horion.auth.presentation.ui.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                io.horion.auth.presentation.ui.pages.password.initResetPasswordPage(ctx)
            },
        ) { pageCtx -> 
            _io_horion_auth_presentation_ui_pages_password_resetPasswordPage()
        }
        ctx.router.register(
            "/verify",
            layoutId = "io.horion.auth.presentation.ui.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                io.horion.auth.presentation.ui.pages.verification.initVerifyPage(ctx)
            },
        ) { pageCtx -> 
            _io_horion_auth_presentation_ui_pages_verification_verifyPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("spin", io.horion.auth.presentation.ui.styles.SpinStyle)
        ctx.theme.registerStyle("loading-container", io.horion.auth.presentation.ui.styles.LoadingContainerStyle)
        ctx.theme.registerStyle("loading-spinner", io.horion.auth.presentation.ui.styles.LoadingSpinnerStyle)
        ctx.theme.registerStyle("loading-text", io.horion.auth.presentation.ui.styles.LoadingTextStyle)
        ctx.theme.registerStyle("loading-content-gap", io.horion.auth.presentation.ui.styles.LoadingContentGapStyle)
        ctx.theme.registerStyle("page-wrapper", io.horion.auth.presentation.ui.styles.PageWrapperStyle)
        ctx.theme.registerStyle("auth-content", io.horion.auth.presentation.ui.styles.AuthContentStyle)
        ctx.theme.registerStyle("profile-content", io.horion.auth.presentation.ui.styles.ProfileContentStyle)
        ctx.theme.registerStyle("auth-title", io.horion.auth.presentation.ui.styles.AuthTitleStyle)
        ctx.theme.registerStyle("avatar", io.horion.auth.presentation.ui.styles.AvatarStyle)
        ctx.theme.registerStyle("avatar-icon", io.horion.auth.presentation.ui.styles.AvatarIconStyle)
        ctx.theme.registerStyle("profile-name", io.horion.auth.presentation.ui.styles.ProfileNameStyle)
        ctx.theme.registerStyle("otp-box", io.horion.auth.presentation.ui.styles.OtpBoxStyle)
        ctx.theme.registerStyle("banner", io.horion.auth.presentation.ui.styles.BannerStyle)
        ctx.theme.registerStyle("top-bar", io.horion.auth.presentation.ui.styles.TopBarStyle)
        ctx.theme.registerStyle("logo", io.horion.auth.presentation.ui.styles.LogoStyle)
        ctx.theme.registerStyle("profile-layout", io.horion.auth.presentation.ui.styles.ProfileLayoutStyle)
        ctx.theme.registerStyle("profile-sidebar", io.horion.auth.presentation.ui.styles.ProfileSidebarStyle)
        ctx.theme.registerStyle("profile-main", io.horion.auth.presentation.ui.styles.ProfileMainStyle)
        ctx.theme.registerStyle("profile-card", io.horion.auth.presentation.ui.styles.ProfileCardStyle)
        ctx.theme.registerStyle("profile-header-card", io.horion.auth.presentation.ui.styles.ProfileHeaderCardStyle)
        ctx.theme.registerStyle("sidebar-nav-item", io.horion.auth.presentation.ui.styles.SidebarNavItemStyle)
        ctx.theme.registerStyle("profile-avatar-container", io.horion.auth.presentation.ui.styles.ProfileAvatarContainerStyle)
        ctx.theme.registerStyle("profile-avatar-icon-size", io.horion.auth.presentation.ui.styles.ProfileAvatarIconSizeStyle)
        ctx.theme.registerStyle("profile-grid", io.horion.auth.presentation.ui.styles.ProfileGridStyle)
        ctx.theme.registerStyle("security-row", io.horion.auth.presentation.ui.styles.SecurityRowStyle)
        ctx.theme.registerKeyframes("spin", io.horion.auth.presentation.ui.styles.SpinAnimation)
        io.horion.auth.initColorMode(ctx)
        io.horion.auth.initStyles(ctx)
        io.horion.auth.initTheme(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        io.horion.auth.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
